export default __webpack_public_path__ + "static/media/hangers.e70f76e4.svg";